import React from 'react'

export const Company = () => {
  return (
    <div>
      Company!
    </div>
  )
}

export default Company;